import Logger from '../lib/logger';

class ExitModal extends HTMLElement {
  #NAME = 'ExitModal'
  #launchBtns
  #modal
  #exitHref

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    //
    this.#modal = this.querySelector('bundler-modal');
    this.#launchBtns = Array.from(document.querySelectorAll('[data-exit-btn]'));
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    //
    this.#launchBtns.forEach(btn => {
      btn.addEventListener('click', (e) => this.#openModal(e));
    });
    //
    this.#modal.addEventListener('modalevent', (e) => this.#onModalEvent(e));
  }

  #openModal = (e) => {
    e.preventDefault();
    Logger.info(`${this.#NAME} > openModal`, e);
    this.#exitHref = e.target.href;
    this.#modal.dataset.show = 'true';
  }
  
  #onModalEvent(e) {
    Logger.info(`${this.#NAME} > onModalEvent`, e.detail);
    //
    if (e.detail.name === 'dismiss') {
      const event = new CustomEvent('custombundle:event', {
        detail: {
          name: 'remove'
        },
        bubbles: true
      });
      this.dispatchEvent(event);
      //
      setTimeout(() => {
        window.location.href = this.#exitHref;
      }, 20);
    } else if (e.detail.name === 'confirm') {
      confirmModal.dataset.show = 'false';
    }
  }
}

customElements.define('exit-modal', ExitModal);